import { Button, Tooltip } from "@mui/material";
import {
  PersonAddOutlined,
  PersonOutlineOutlined,
} from "@mui/icons-material";

const StyledTooltip = ({ title, children }) => (
  <Tooltip
    title={title}
    placement="top"
    arrow
    PopperProps={{
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, -5],
          },
        },
      ],
    }}
    componentsProps={{
      tooltip: {
        sx: {
          bgcolor: "#666",
          color: "white",
          fontSize: "12px",
          fontWeight: "500",
          borderRadius: "4px",
          padding: "6px 8px",
          "& .MuiTooltip-arrow": {
            color: "#666",
          },
        },
      },
    }}
  >
    {children}
  </Tooltip>
);

const FollowButton = ({ isFollowing, onToggle }) => {
  return (
    <StyledTooltip
      title={
        isFollowing
          ? "Click to unfollow this person"
          : "Click to follow this person"
      }
    >
      <Button
        startIcon={
          isFollowing ? <PersonOutlineOutlined /> : <PersonAddOutlined />
        }
        onClick={onToggle}
        variant="contained"
        sx={{
          width: "97px",
          height: "32px",
          backgroundColor: isFollowing ? "#F3E5F5" : "#7B1FA2",
          color: isFollowing ? "#4A148C" : "white",
          fontSize: "12px",
          fontWeight: "500",
          textTransform: "none",
          borderRadius: "6px",
          border: isFollowing ? "1px solid #4A148C" : "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: isFollowing ? "#EFDBE3" : "#5a1a73",
            boxShadow: "none",
          },
          "& .MuiButton-startIcon": {
            color: isFollowing ? "#4A148C" : "white",
          },
        }}
      >
        {isFollowing ? "Following" : "Follow"}
      </Button>
    </StyledTooltip>
  );
};

export default FollowButton;
